/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/merge_fighter_3': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 11.75v-7.5h-7.5L16 0l-4.25 4.25h-7.5v7.5L0 16l4.25 4.25v7.5h7.5L12 28v4h8v-4l.25-.25h7.5v-7.5L32 16l-4.25-4.25zm-23 15.5v-6.5l6.5 6.5h-6.5zm0-16v-6.5h6.5l-6.5 6.5zm10.584.75h1.332v1.333h-1.332V12zM14.3 26.886V30h-.6V26h.6v.886zm2 1.4V30h-.6v-4h.6v2.286zm2-2V30h-.6v-4h.6v.286zM16 22l-4-8h8l-4 8zm11.25 5.25h-6.5l6.5-6.5v6.5zm0-16l-6.5-6.5h6.5v6.5z"/>'
  }
})
